import { render, staticRenderFns } from "./activeUserList.vue?vue&type=template&id=131ec2da&scoped=true"
import script from "./activeUserList.vue?vue&type=script&lang=js"
export * from "./activeUserList.vue?vue&type=script&lang=js"
import style0 from "./activeUserList.vue?vue&type=style&index=0&id=131ec2da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ec2da",
  null
  
)

export default component.exports